import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import(
// @ts-expect-error untyped dependency
/* webpackChunkName: "SingleReportViewerModalContainer" */
'./SingleReportViewerContainer');
export const AsyncSingleReportViewerContainer = Loadable({
  loader,
  LoadingComponent: () => null
});